export default {
    manage_createEditEquipment_EditTitle: "Edit Equipment",
    manage_createEditEquipment_CreateTitle: "Create new Equipment",
    manage_createEditEquipment_success: "Equipment was created successfully",
    manage_createEditEquipment_success_edit: "Equipment was updated successfully",
    manage_createEditEquipment_duplicatedEquipmentErrorMessage: "This Equipment already exists",
    manage_createEditEquipment_NameInputLabel: "Equipment Name"
}